import {
  formatFilterLabelWithCount,
  getInfluencerColumnStatusFilterCount,
} from "@widgets/CampaignBrief/lib/campaignBriefFilterFacetCounts";
import {
  INFLUENCER_COLUMN_STATUS_FILTER_OPTIONS,
  InfluencerColumnStatusFilterValue,
} from "@widgets/CampaignBrief/lib/influencerColumnStatusFilter";
import { useBriefInfluencerFilterStore } from "@widgets/CampaignBrief/store/useBriefInfluencerFilterStore";
import { ISearchFacets } from "@shared/lib/types/briefInfluencerV2";
import { SearchSingleSelectFilter } from "@shared/ui/filters/SearchSingleSelectFilter";

interface InfluencerColumnStatusFilterProps {
  confirm: () => void;
  close: () => void;
  searchFacets?: ISearchFacets;
  before?: React.ReactNode;
}

export function InfluencerColumnStatusFilter({
  confirm,
  close,
  searchFacets,
  before,
}: InfluencerColumnStatusFilterProps) {
  const { feFilters, setFilters, saveFilters } =
    useBriefInfluencerFilterStore();

  const handleApply = (value?: string) => {
    setFilters({
      ...feFilters,
      columnStatusFilters: value
        ? [value as InfluencerColumnStatusFilterValue]
        : [],
    });
    saveFilters();
  };

  return (
    <SearchSingleSelectFilter
      confirm={confirm}
      close={close}
      before={before}
      options={INFLUENCER_COLUMN_STATUS_FILTER_OPTIONS.map((option) => ({
        label: formatFilterLabelWithCount(
          option.label,
          getInfluencerColumnStatusFilterCount(searchFacets, option.value)
        ),
        value: option.value,
      }))}
      selectedValue={feFilters.columnStatusFilters?.[0]}
      onApply={handleApply}
      searchPlaceholder="Search status"
    />
  );
}
